<script setup>
import useGrid from "@/composables/useGrid";
import needsService from "@/services/needs.service";
import Grid from "../../../../frontend/src/components/Grid.vue";
import {onMounted} from "vue";

const {items, gridParams, gridMethods} = useGrid(needsService.getList);

const columns = [
    {
        label: 'ID',
        name: 'id',
    },
    {
        label: 'Name',
        name: 'name',
    },
    {
        label: 'Description',
        name: 'description',
    },
    {
        label: 'Enterprise',
        name: 'enterprise_name',
    },
    {
        label: 'Created by',
        name: 'user_email',
    },
    {
        label: 'Status',
        name: 'status',
    },
    {
        label: 'Added by AI',
        name: 'ai_count',
    },
    {
        label: 'Added by Ecosystem',
        name: 'eco_count',
    },
    {
        label: 'Liked',
        name: 'liked_count',
    },
    {
        name: 'actions',
        label: 'Link',
        component: 'Link',
    },
];

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});
</script>

<template>
    <div>
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                    @changeFilters="gridMethods.setFilters"
                    @changeSort="gridMethods.changeSort"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
